import React, { type ComponentPropsWithoutRef, forwardRef } from 'react';

import { isKey } from '../../../helpers/keyboard';

import { Styled } from './styles';

type RadioProps = {
  checked: boolean;
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
};
type SpanProps = Omit<ComponentPropsWithoutRef<'span'>, keyof RadioProps>;
type InputPropsToForward = Pick<ComponentPropsWithoutRef<'input'>, 'name' | 'id' | 'form'>;

type Props = SpanProps & InputPropsToForward & RadioProps;

export const Radio = forwardRef<HTMLDivElement, Props>(
  ({ disabled = false, checked = false, onChange, ...props }, ref) => (
    <Styled.Container
      {...props}
      tabIndex={disabled ? undefined : 0}
      role="radio"
      aria-disabled={disabled}
      aria-checked={checked}
      ref={ref}
      onKeyDown={event => {
        if (isKey('space')(event)) {
          event.preventDefault();
          onChange?.(!checked);
        }
        props.onKeyDown?.(event);
      }}
      onClick={
        disabled
          ? undefined
          : event => {
              onChange?.(!checked);
              props.onClick?.(event);
            }
      }
      disabled={disabled}
      checked={checked}
    >
      <input type="radio" checked={checked} disabled={disabled} style={{ display: 'none' }} readOnly />
      <Styled.OuterCircle disabled={disabled} checked={checked}>
        {checked && <Styled.InnerCircle disabled={disabled} checked />}
      </Styled.OuterCircle>
    </Styled.Container>
  ),
);
